import {Directive, ElementRef, OnInit, Input, Output, EventEmitter} from '@angular/core';

declare var $: any;

@Directive({
    selector: '[smartTags]'
})
export class SmartTagsDirective implements OnInit {

    constructor(private el: ElementRef) {
    }

    @Input() smartTags: any;
    @Output() tagChanged: EventEmitter<any> = new EventEmitter();

    ngOnInit() {
        System.import('script-loader!bootstrap-tagsinput/dist/bootstrap-tagsinput.min.js').then(() => {
            this.render()
        })
    }


    render() {
        $(this.el.nativeElement).tagsinput(this.smartTags || {});
        $(this.el.nativeElement).on('itemAdded', (event) => {
            this.tagChanged.emit(event.item);
        });

        $(this.el.nativeElement).on('itemRemoved', (event) => {
            this.tagChanged.emit(event.item);
        });
    }


}
